// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"dac616d9","787":"70fa7295"}[chunkId] + ".chunk.js";
};